function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailSmall = function SvgEmailSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    fillRule: "evenodd",
    d: "M6.964 7.827A.4.4 0 0 1 7.2 7.75h9.6a.4.4 0 0 1 .236.077L12 12.024zM6.75 9.601v6.149c0 .303.233.5.45.5h9.6c.217 0 .45-.197.45-.5V9.601l-4.77 3.975a.75.75 0 0 1-.96 0zM7.2 6.25c-1.103 0-1.95.928-1.95 2v7.5c0 1.073.847 2 1.95 2h9.6c1.103 0 1.95-.927 1.95-2v-7.5c0-1.072-.847-2-1.95-2z",
    clipRule: "evenodd"
  }));
};
export default SvgEmailSmall;